module.exports = __webpack_public_path__ + "static/media/lds.b700618e.png";